<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="Ordenar reglamento"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showOrdenarReglamento"
    @hidden="reset"
  >
    <draggable
      v-model="list"
      class="list-group list-group-flush cursor-move"
      tag="ul"
    >
      <transition-group type="transition" name="flip-list">
        <b-list-group-item
          v-for="listItem in listReglamento"
          :key="listItem.motivo"
          tag="li"
        >
          <div class="d-flex">
            <div class="ml-25">
              <b-card-text class="font-weight-bold mb-0">
                {{ listItem.motivo }}
              </b-card-text>
            </div>
          </div>
        </b-list-group-item>
      </transition-group>
    </draggable>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-if="!showLoading"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="ordenar"
      >
        Confirmar
      </b-button>
      <div v-if="showLoading" class="text-center mt-1">
        <b-spinner variant="primary" label="Text Centered" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BSpinner,
  BListGroupItem,
  BCardText,
  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import draggable from 'vuedraggable'
import { computed, ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  //   USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    draggable,
    BListGroupItem,
    BCardText,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    listReglamento: Array,
    tarjetasAplicadas: Number,
  },
  setup(props, { emit }) {
    const showLoading = ref(false)
    const { postApi } = apiCall()
    const opcion = ref(null)
    const list = computed({
      get: () => props.listReglamento,
      set: value => {
        // crearLista(value)
        // props.listReglamento = value
        emit('ordenar', value)
      },
    })
    function close() {
      store.commit('someVariables/UPDATE_SHOW_ORDENAR_REGLAMENTO', false)
    }
    function reset() {
      opcion.value = null
    }
    async function ordenar() {
      list.value.forEach((element, index) => {
        element.new_pos = index
      })
      // console.log(list)

      showLoading.value = true
      const path = 'ApiSanciones/ordenarReglamento'
      const data = {
        lista: list.value,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        // console.log('si')
        emit('ordenarReglamento', data.idPartido)
        close()
        // dataPartido.value.voc_revisada = 's'
        // insertMultasTarjetasAutomatico()
      }
      showLoading.value = false
    }

    return {
      close,
      ordenar,
      showLoading,
      opcion,
      reset,
      list,
    }
  },
}
</script>
<style>
.list-group-item {
  transition: all 0.5s;
}
</style>
